import quiltData from './quiltData';
import wallHangingsData from './wallHangingsData';
import smallPiecesData from './smallPiecesData';
import inSituData from './inSituData';      
import balsamPillowData from './balsamPillowData';
import pillowsData from './pillowsData';

export default quiltData.concat(wallHangingsData, smallPiecesData, inSituData, balsamPillowData, pillowsData);